import React, { Component } from 'react';
import './TickerBase.css';

class Marquee extends Component {
  constructor(props) {
    super(props);

    this.state = {
      containerWidth: 0,
      marqueeWidth: 0,
      multiplier: 1,
      isMounted: false,
    };

    this.containerRef = React.createRef();
    this.marqueeRef = React.createRef();
  }

  calculateWidth = () => {
    if (this.marqueeRef.current && this.containerRef.current) {
      const containerRect = this.containerRef.current.getBoundingClientRect();
      const marqueeRect = this.marqueeRef.current.getBoundingClientRect();
      const containerWidth = containerRect.width;
      const marqueeWidth = marqueeRect.width;

      const multiplier =
        this.props.autoFill && containerWidth && marqueeWidth && marqueeWidth < containerWidth
          ? Math.ceil(containerWidth / marqueeWidth)
          : 1;

      this.setState({
        containerWidth,
        marqueeWidth,
        multiplier,
      });
    }
  };

  windowResizeObserver = () => {
    if (this.resizeObserver) return;

    if (this.marqueeRef.current && this.containerRef.current) {
      this.resizeObserver = new ResizeObserver(() => this.calculateWidth());
      this.resizeObserver.observe(this.containerRef.current);
      this.resizeObserver.observe(this.marqueeRef.current);
    }
  };

  componentDidMount() {
    this.setState({ isMounted: true });
    this.calculateWidth();
    this.windowResizeObserver();
  }

  componentWillUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.children !== this.props.children) {
      this.calculateWidth();
      this.windowResizeObserver();
    }
  }

  renderChildren = () =>
    React.Children.map(this.props.children, (child) => {
      return <div className="child">{child}</div>;
    });

  multiplyChildren = (multiplier) => {
    return [...Array(Number.isFinite(multiplier) && multiplier >= 0 ? multiplier : 0)].map((_, i) => (
      <React.Fragment key={i}>
        {React.Children.map(this.props.children, (child) => (
          <div className="child">{child}</div>
        ))}
      </React.Fragment>
    ));
  };

  render() {
    const { multiplier, isMounted } = this.state;
    if (!isMounted) {
      return null;
    }

    const { className = '', direction = 'left', delay = 0, duration = 80 } = this.props;

    const marqueeStyle = {
      '--direction': direction === 'left' ? 'normal' : 'reverse',
      '--duration': `${duration}s`,
      '--delay': `${delay}s`,
    };

    return (
      <div ref={this.containerRef} className={'marquee-container ' + className}>
        <div className="marquee" style={marqueeStyle}>
          <div className="initial-child-container" ref={this.marqueeRef}>
            {this.renderChildren()}
          </div>
          {this.multiplyChildren(multiplier - 1)}
        </div>
        <div className="marquee" style={marqueeStyle}>
          {this.multiplyChildren(multiplier)}
        </div>
      </div>
    );
  }
}

export default Marquee;
